import React, { useEffect, useState } from 'react';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, Link } from 'react-router-dom';
// Slice
import { setActiveLoginModal } from '../../app/features/userSlice';
import { resetMetasearch } from '../../app/features/metasearchSlice';
import { resetDictionaty as resetDictionatyAction } from '../../app/features/dictionarySlice';
import {
	resetFilters as resetFiltersAction,
	setLibrary as setLibraryAction,
	resetLibrary as resetLibraryAction,
} from '../../app/features/librarySlice';
import {
	setResetNewsQuery as setResetNewsQueryAction,
	setNews as setNewsAction,
} from '../../app/features/newsSlice';
import { resetUserData as resetUserDataAction } from '../../app/features/userSlice';
import { resetPatents as resetPatentsAction } from '../../app/features/patentsSlice';
import { resetJobs as resetJobsAction } from '../../app/features/jobsSlice';
import { resetMultimedia as resetMultimediaAction } from '../../app/features/multimediaSlice';
// Icons
import { FaChevronDown } from 'react-icons/fa';
import closeIcon from '../../Images/Login/LoginPage/close.svg';
// Utils
import { getInitials } from '../../utils/getInitials';
// Style
import './Login.css';
// Translate
import { useTranslation } from 'react-i18next';

const Login = () => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const currentlyRoute = pathname.replace('/', '');

	const { requestLogin, uniqueLogin, institutionCode } = useSelector(
		(state) => state.institution,
	);
	const { user_email, user_name, user_lastname } = useSelector(
		(state) => state.user,
	);

	useEffect(() => {
		if (requestLogin) {
			if (
				user_email.length === 0 &&
				user_name.length === 0 &&
				user_lastname.length === 0 &&
				currentlyRoute !== '' &&
				currentlyRoute !== 'login'
			) {
				dispatch(setActiveLoginModal(true));
				navigate(`/`);
			}
		} else {
			!institutionCode && navigate(`/`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [isOpenCloseSession, setIsOpenCloseSession] = useState(false);

	const initialsName = () => {
		const initialsFirstName = user_name ? getInitials(user_name) : '';
		const initialsLastName = user_lastname ? getInitials(user_lastname) : '';
		const initials = initialsFirstName + initialsLastName;
		const final = initials
			? initials
			: user_email.length > 0
				? user_email[0].toUpperCase()
				: '';
		return final ? final : 'USER';
	};

	const closeSession = () => {
		setIsOpenCloseSession(false);

		dispatch(resetUserDataAction()); // Reinicia variables de datos de usuario
		dispatch(resetMetasearch()); // Reinicia los estados de Metasearcher
		navigate(`/`);
		// restart all variables
		dispatch(setLibraryAction([])); // Reinicia la data de Library
		dispatch(resetFiltersAction()); // Reinicia Filtros de Library
		dispatch(resetLibraryAction()); // Reinicia estados de Library
		dispatch(resetDictionatyAction()); // Reinicia estados de Dictionary
		dispatch(setResetNewsQueryAction()); // Reinicia estados de News
		dispatch(setNewsAction([])); // Reinicia la data de News
		dispatch(resetPatentsAction()); // Reinicia estados de Patents
		dispatch(resetMultimediaAction()); // Reinicia estados de Multimedia
		dispatch(resetJobsAction()); // Reinicia estados de Jobs

		// Redireccion a Home
		navigate('/');
	};

	const setLogin = () => {
		if (user_email?.length > 0) {
			if (currentlyRoute !== '') {
				return (
					<>
						<div
							className='userLoggedContainer'
							role='button'
							onClick={() => setIsOpenCloseSession(!isOpenCloseSession)}
						>
							<div className='userLogged'>{initialsName()}</div>
							<FaChevronDown />
						</div>

						{isOpenCloseSession && (
							<button className='closeSession' onClick={closeSession}>
								<p>{t('Sign off')}</p>
								<img src={closeIcon} alt='close' />
							</button>
						)}
					</>
				);
			} else {
				return null;
			}
		} else {
			return (
				<div className='logiOptionsContainer'>
					<button
						onClick={() => dispatch(setActiveLoginModal(true))}
						className='bg-white text-black rounded-full px-4 py-2 border-none hover:!bg-green-aquinas transition-colors duration-200'
					>
						{t('Sign in')}
					</button>

					{uniqueLogin && (
						<Link
							to='signup'
							className='text-white rounded-full px-4 py-2 border-none hover:!bg-green-aquinas transition-colors duration-200'
						>
							{t('Sign up')}
						</Link>
					)}
				</div>
			);
		}
	};

	if (requestLogin) {
		return setLogin();
	}
};

export default Login;
